module.exports = __webpack_public_path__ + "static/media/received_7669869456396888.ace8dc67.jpeg";